const urlToHttpsUrl = (value: string | undefined) => {
  let url = value?.replace(/\s+/g, '').replace(/http:\/\//, 'https://') || 'https://';
  if (value === 'https:/') url = 'https://';
  if (url.indexOf('https://') !== 0) url = `https://${url}`;
  return url;
};

export default urlToHttpsUrl;
